import type { FeatureFlags } from '@repo/wemod-api/features/schema';
import { TOKEN_COOKIE_NAME } from '../auth/constants';
import { readClientCookie } from '../utils/cookie-utils';
import { type RequestFeatureFlagsOptions, requestFeatureFlags } from './request';

export type { FeatureFlags };
export type FetchFeatureFlagsClientSideOptions = RequestFeatureFlagsOptions;

/** Client-side fetch; reads the auth token cookie from `document.cookie` when present. */
export async function fetchFeatureFlagsClientSide(
    options: FetchFeatureFlagsClientSideOptions = {},
): Promise<FeatureFlags> {
    const bearerToken = options.bearerToken ?? readClientCookie(TOKEN_COOKIE_NAME);
    return requestFeatureFlags({ bearerToken });
}
